import { orgsRequest } from './request';

const ORG_ID_QUERY = `
query OrgId($raiseId: Int!) {
  orgId(raiseId: $raiseId)
}`;

export const getOrgId = async (raiseId: string): Promise<string> => {
  const orgsIdRes = await orgsRequest(ORG_ID_QUERY, {
    raiseId: parseInt(raiseId),
  });
  const orgsIdResJson = await orgsIdRes.json();
  return orgsIdResJson.data.orgId;
};
